export const sortArrNumerically = <TItem extends Record<any, any>>(
  arr: TItem[],
  field: keyof TItem,
  isDesc?: boolean,
) => arr.sort((a, b) => (isDesc ? b[field] - a[field] : a[field] - b[field]));
